const StringConstants = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete',
  MISSING_PARAM: 'missing param',

  // direction
  NEXT: 'next',
  PREV: 'prev',

  FORMATTED_BRAND_NAMES: {
    hotpads: 'HotPads',
    zillow: 'Zillow',
    trulia: 'Trulia',
  },

  // using the plain brand names for hotpads and trulia for now whenever we need to use ZRM brand for zillow
  FORMATTED_BRAND_NAMES_RENTAL: {
    hotpads: 'HotPads',
    zillow: 'Zillow Rental Manager',
    trulia: 'Trulia',
  },

  UNFORMATTED_BRAND_NAMES: {
    hotpads: 'hotpads',
    zillow: 'zillow',
    trulia: 'trulia',
  },

  GA_TRACKERS: {
    dsp: 'dsp',
    gtm: 'gtm',
    zillow: 'zillow',
  },

  // marketing
  MARKETING_PATH: {
    PAYMENTS: 'payments',
    APPLICATIONS: 'applications',
    LEASES: 'leases',
  },

  ALLOW_PARAMS_REGEX: '([?].*)?([&].*)?',
  ALLOW_TENANTS_PARAMS_REGEX: '(manage-tenants|find-tenants)',

  // server side error string identifier
  // only for BE status code > 399 that are to be fixed in near future
  SS_ERRORS: {
    confirm_phone_number: 'Verification required',
    invalid_phone_number: 'Not a valid 10 digit phone number',
  },

  MOBILE_PLATFORMS: {
    ANDROID: 'android',
    IOS: 'ios',
  },
};

export default StringConstants;
